import { Component } from '@angular/core';

@Component({
    selector: 'learner',
    templateUrl: './learner.template.html',
    styleUrls: ['./learner.style.scss'],
    standalone: false
})

export class Learner {

  constructor () {}

  ngOnInit() {  
  }
}